export const PAYMENT_TYPES = {
    cash: 0,
    card: 1,
    payPal: 2
};
